import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as RuleModalActions from 'web-app/react/modals-container/move-rule-modal/actions';

import * as Actions from './actions';

const State = Record({
    results: List(),
    rules: null,
    currentQuery: null,
    updating: false,
    searching: false,
});

export default handleActions(
    {
        [RuleModalActions.saveRules.type]: (state, {payload}) =>
            state.merge({
                rules: payload.rules,
            }),
        [Actions.reset.type]: () => new State(),
        [Actions.save.type]: state =>
            state.merge({
                updating: true,
            }),

        [Actions.saveSuccess.type]: state =>
            state.merge({
                rules: null,
                updating: false,
            }),

        [Actions.saveFailed.type]: state =>
            state.merge({
                updating: false,
            }),

        [Actions.saveAborted.type]: state =>
            state.merge({
                updating: false,
            }),
        [Actions.search.type]: (state, {payload}) =>
            state.merge({
                currentQuery: payload.queryString,
                searching: true,
            }),

        [Actions.searchSuccess.type]: (state, {payload}) =>
            state.merge({
                results: payload.results,
                searching: false,
            }),

        [Actions.searchAborted.type]: state =>
            state.merge({
                searching: false,
            }),

        [Actions.searchFailed.type]: state =>
            state.merge({
                searching: false,
            }),
    },
    new State(),
);
